import React from "react";
import { Col } from "react-bootstrap";
import Input from "../../form/SafePlaceInput";
import "./index.scss";

export default function UserEmailForm({ currentUser, register, errors }) {
  return (
    <Col xs={12} className="userEmailSection">
      <Input
        type="email"
        placeholder={currentUser?.email}
        name="email"
        ref={register()}
        errors={errors}
      />
    </Col>
  );
}
